import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgNoTemplate = (props) => /* @__PURE__ */ _jsxs("svg", {
	id: "Calque_1",
	xmlns: "http://www.w3.org/2000/svg",
	xmlnsXlink: "http://www.w3.org/1999/xlink",
	x: "0px",
	y: "0px",
	viewBox: "0 0 1024 1024",
	style: { enableBackground: "new 0 0 1024 1024" },
	xmlSpace: "preserve",
	...props,
	children: [
		/* @__PURE__ */ _jsx("style", {
			type: "text/css",
			children: "\n	.st0{fill-rule:evenodd;clip-rule:evenodd;}\n	.st1{fill:none;stroke:#000000;stroke-width:30;}\n	.st2{fill:none;stroke:#000000;stroke-width:30;stroke-linecap:round;}\n"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "st0",
			d: "M322.6,807.6c0,14.1,11.5,25.6,25.6,25.6s25.6-11.5,25.6-25.6V676.7c0-14.1-11.5-25.6-25.6-25.6 s-25.6,11.5-25.6,25.6V807.6z M322.6,586.6c0,14.1,11.5,25.6,25.6,25.6s25.6-11.5,25.6-25.6v-3.4c0-14.1-11.5-25.6-25.6-25.6 s-25.6,11.5-25.6,25.6V586.6z"
		}),
		/* @__PURE__ */ _jsx("circle", {
			className: "st1",
			cx: 348.2,
			cy: 686.1,
			r: 199.7
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "st2",
			d: "M619.5,184.3H112.6c-22.6,0-41,18.3-41,41v686.1c0,22.6,18.3,41,41,41h686.6c22.6,0,41-18.3,41-41V430.1"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "st2",
			d: "M546.1,388.4L865.4,98.7c4-3.7,10.3-3.5,14.1,0.3l75.5,75.3c4.1,4.1,4,10.9-0.4,14.8l-319,289.4 c-1.9,1.7-4.3,2.7-6.9,2.7H553c-5.7,0-10.2-4.6-10.2-10.2v-75C542.7,393.1,543.9,390.4,546.1,388.4z"
		})
	]
});
export default SvgNoTemplate;
